// Sort comparators for staff document records (clearances, skills, confidential).

export const byNewest = (a, b) => String(b.added_at || "").localeCompare(String(a.added_at || ""));

// Soonest expiry first (expired at the top), no-expiry documents last; newest-added breaks ties.
export const bySoonestExpiry = (a, b) => {
  const ae = a.expiry_date || "", be = b.expiry_date || "";
  if (ae !== be) {
    if (!ae) return 1;
    if (!be) return -1;
    return ae.localeCompare(be);
  }
  return byNewest(a, b);
};
